import { NewsWidget, WidgetHost } from '@/core/widgets/export';
import { RouteObject } from 'react-router-dom';
import DataReleaseHistoryNavigator from '@/modules/calendar/components/data/data-release-history-navigator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine } from '@fortawesome/free-solid-svg-icons';
import { Permissions } from '@/core/permissions/export';

export class DataReleaseHistoryWidget implements NewsWidget {
  get defaultRoute(): string {
    return '';
  }

  get defaultTitle(): string {
    return 'Data History';
  }

  async hasPermission(permissions: string[]): Promise<boolean> {
    return permissions.includes(Permissions.ALPHA_ACCESS);
  }
  shouldHideToUser(permissions: string[]): boolean {
    return !permissions.includes(Permissions.ALPHA_ACCESS);
  }

  headerActions({ children }: { children?: React.ReactNode }): JSX.Element {
    return <>{children}</>;
  }

  get headerPanel(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faChartLine} /> Data History
      </>
    );
  }

  get id(): string {
    return 'data-release-history';
  }

  initialize(host: WidgetHost): void {}

  get routes(): RouteObject[] {
    return [
      {
        path: '/',
        element: <DataReleaseHistoryNavigator />,
      },
      {
        path: '/:id',
        element: <DataReleaseHistoryNavigator />,
      },
    ];
  }

  get shortTitle(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faChartLine} /> Data History
      </>
    );
  }
}
